<mat-accordion multi>
    <mat-expansion-panel hideToggle class="dashboard-recent" [disabled]="!projects.length">
        <mat-expansion-panel-header>
            <!-- <mat-icon>schedule</mat-icon> -->
            <mat-panel-title>
                <span class="italic font-extrabold text-xl">{{ 'HISTORY' | translate}} -&nbsp;</span>
                <span class="italic font-extralight text-xl">{{ 'LAST_10_ENTRIES' | translate }}</span>
            </mat-panel-title>
            <mat-panel-description class="flex justify-end">
                <button *ngIf="projects?.length" mat-icon-button [disableRipple]="true" (click)="refreshProjectsCards($event)">
                    <mat-icon>restart_alt</mat-icon>
                </button>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-divider></mat-divider>
        <div *ngIf="projects" class="bg-tw-lightgrey bg-opacity-40 rounded-xl p-2">
            <table class="w-full my-2">
                <thead class="h-8">
                    <tr class="text-tw-text-disabled italic tr-extralight">
                        <th class="w-[5%]">{{ 'THUMB' | translate }}</th>
                        <th class="w-[20%]">{{ 'JOB_NAME' | translate }}</th>
                        <th class="w-[5%]"><!-- EasyDiadem? --></th>
                        <th class="w-[5%]"><!-- FLOW --></th>
                        <th class="w-[15%] pl-4">{{ 'EXTERN_STATE' | translate }}</th>
                        <th class="w-[15%] pl-4" *ngIf="!isClient()">{{ 'INTERN_STATE' | translate }}</th>
                        <th class="pl-2">{{ 'SPLITVIEWS' | translate }}</th>
                        <th class="w-[10%] px-3">{{ 'CREATION_DATE' | translate }}</th>
                        <th class="w-[10%]" *ngIf="!isClient()">{{ 'ACTIONS' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- CHILD CARD -->
                    <tr *ngFor="let project of projects" app-project-child-card [project]="project"></tr>
                </tbody>
            </table>
        </div>
    </mat-expansion-panel>
</mat-accordion>